module.exports = __webpack_public_path__ + "img/av.09741f25.png";